import CentralMensagens from '~modulos/central-mensagens/componentes/CentralMensagens.vue';
import SolicitacaoCompraRelatorio from '~modulos/solicitacao-compra/componentes/SolicitacaoCompraRelatorio.vue';

export default {
  path: '/mensagem',
  component: CentralMensagens,
  meta: { auth: true, semCabecalho: true },
  name: 'mensagem',
  children: [
    {
      path: '/solicitacao-compra/:id/relatorio',
      component: SolicitacaoCompraRelatorio,
      name: 'mensagem-compra.relatorio'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/mensagem/rotas.js